import { useMutation, useQuery } from "@tanstack/react-query";
import { api, depositApi } from "./api.service";

export const useDepositAddressByChain = () => {
  return useMutation({
    mutationFn: (chain: string) =>
      depositApi.get(`/get-deposit-address/${chain}`),
  });
};

export const useGetUserDeposits = (
  userId: string,
  page: number = 1,
  pageSize: number = 10,
  hash?: string,
) => {
  const config = { withCredentials: true };

  return useQuery({
    queryKey: ["get-user-deposits", userId, page, pageSize, hash],
    queryFn: async () => {
      const params = { page, pageSize, hash };
      const response = await depositApi.get(`/user/${userId}`, {
        ...config,
        params,
      });
      console.log("response ...", response.data);
      return response.data;
    },
    refetchOnWindowFocus: false,
    retry: 0,
  });
};

export const useGetUserWithdraw = (
  userId: string,
  page: number = 1,
  pageSize: number = 10,
  hash?: string,
) => {
  const config = { withCredentials: true };

  return useQuery({
    queryKey: ["get-user-withdraw", userId, page, pageSize, hash],
    queryFn: async () => {
      const params = { page, pageSize, hash };
      const response = await api.get(`/withdraw/user/${userId}`, {
        ...config,
        params,
      });
      console.log("response ...", response.data);
      return response.data;
    },
    refetchOnWindowFocus: false,
    retry: 0,
  });
};

export const useCancelWithdraw = () => {
  return useMutation({
    mutationFn: async (id: string) => {
      await api.post(`/withdraw/cancel`, {
        id: id,
      });
    },
    retry: 0,
  });
};

interface DepositData {
  amount: number;
  usdAmount: number;
  network: string;
  token: string;
  promoCode: string;
  recipientAddress: string;
}

export const useCreateDepositForm = () => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  return useMutation({
    mutationFn: (data: DepositData) =>
      api.post("/transactions/deposit", data, config),
  });
};
